module.exports = __webpack_public_path__ + "static/media/training-icon.d76c76c0.svg";